module.exports = __webpack_public_path__ + "static/media/builder_calculations.07369b41.gif";